import { useSelector } from 'react-redux';

import { QUESTIONNAIRE_STATUS, Roles } from '../../../../constants';
import { areUserRolesIn } from '../../../../helpers/auth-helpers';

import type { RootState } from '../../../../store';
import type { QuestionnaireReadOnlyDetails, QuestionnaireReadOnlyState } from './types';

// A questionnaire is locked for editing once it is concluded (isCompleted), or for anyone who is
// not a guardian (e.g. staff reviewing a client's answers). It also stays locked while the details
// in the store don't yet match the id in the URL — during that window the store still holds the
// previously loaded questionnaire (or nothing), so trusting its status could open a completed
// questionnaire for editing before its real data arrives. isReadOnly covers all three.
export default function useIsQuestionnaireReadOnly(
  details: QuestionnaireReadOnlyDetails | null,
  questionnaireId: string | undefined,
): QuestionnaireReadOnlyState {
  const userRoles = useSelector((state: RootState) => state.auth.user?.roles);

  const isLoadedIdCurrent = !!details && String(details.id) === questionnaireId;
  const isCompleted = isLoadedIdCurrent && details.status === QUESTIONNAIRE_STATUS.COMPLETED;
  const isReadOnly =
    !isLoadedIdCurrent || isCompleted || !areUserRolesIn(userRoles, [Roles.Guardian]);

  return { isCompleted, isReadOnly };
}
